import script from "./FileInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFile});
